import { render, staticRenderFns } from "./MonitorItemCat1.vue?vue&type=template&id=3558dfcd&scoped=true"
import script from "./MonitorItemCat1.vue?vue&type=script&lang=js"
export * from "./MonitorItemCat1.vue?vue&type=script&lang=js"
import style0 from "./MonitorItemCat1.vue?vue&type=style&index=0&id=3558dfcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3558dfcd",
  null
  
)

export default component.exports